import { Link } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'

export const meta = () => [{ title: 'JaseOwns - Projects' }]

export default function Index() {
	return (
		<div className="container mx-auto text-black dark:text-white">
			<section id="projects">
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">Current Projects</h1>
				<div className="justify-center mb-6 md:mb-12 text-xl px-10 flex flex-col space-y-6 md:space-y-0 md:space-x-16 md:flex-row">
					<div>
						<a href="https://uoaddicts.com" className="underline"><img src="/images/uoaddicts.png" alt="UO Addicts" /></a>
						<h2 className="text-2xl font-bold my-2 md:my-4">UORazorScripts & UOAddicts</h2>
						<p><a href="https://uorazorscripts.com" className="underline">UORazorScripts.com</a> aims to be a collaboration of UO Razor Scripts by the players for the players.</p>
						<p><a href="https://uoaddicts.com" className="underline">UOAddicts.com</a> is the expansion pack of UORazorScripts - it will bridge the gap of all things UO related.</p>
					</div>
					<div>
						<Link to="/gaming/ultima-online/new-player-guides" className="underline"><img src="/images/new-player-guide.png" className="w-full" alt="New Player Guides" /></Link>
						<h2 className="text-2xl font-bold my-2 my:mb-4">New Player Guides</h2>
						<p>Starting with UO - check out <Link to="/gaming/ultima-online/new-player-guides" className="underline">New Solo Player - Getting Started Guides</Link>. I attempt to break down how to play different templates for someone who has never played before.</p>
					</div>
					<div>
						<Link to="/gaming/everquest-legends" className="underline"><img src="/images/gaming/everquest/eql-logo.jpg" className="w-1/2" alt="EverQuest Legends Guides" /></Link>
						<h2 className="text-2xl font-bold my-2 md:my-4">EverQuest Legends - Dungeon Runs</h2>
						<p>Fresh character, long road, one dungeon. I stream <Link to="/gaming/everquest-legends" className="underline">EverQuest Legends</Link> dungeon runs live, and built a <Link to="/gaming/everquest-legends/dungeon-runs" className="underline">route planner</Link> - pick a race and see the zone-by-zone path from your starting city to every dungeon.</p>
					</div>
				</div>
				<div className="justify-center mb-6 md:mb-12 text-xl px-10 flex flex-col space-y-6 md:space-y-0 md:space-x-16 md:flex-row">
					<div>
						<img src="/images/shared-chat.png" alt="SharedChat Bot" />
						<h2 className="text-2xl font-bold my-2 md:my-4">SharedChat</h2>
						<p>Shared.chat was a passion project of mine that allows multi-platform streamers to have chat interact directly with each other.  I was going to try and sell it but for now it is just used on my personal streams.</p>
					</div>
					<div>
						<h2 className="text-2xl font-bold my-2 md:my-4"><img src="/images/youtube.png" alt="JaseOwns on YouTube" className='inline-block h-12' /> YouTube Channel</h2>
						<p>I have always been interested in YouTube videos but during 2019 and 2020 I started actually doing uploads. Check out my channel <a href="https://youtube.com/jaseowns" className="underline" >Youtube.com/jaseowns</a> or <Link to="/videos" className="underline">view videos</Link> directly on the site</p>
					</div>
					<div>
						<h2 className="text-2xl font-bold my-2 md:my-4"><img src="/images/twitch.png" alt="JaseOwns on Twitch" className='inline-block h-12' /> Streamer list of UO Players</h2>
						<p>I want to spread the love of UO Streamers so I've been working on providing a list of <Link to="/streamers" className='underline'>who is streaming Ultima Online</Link> - this will be added to our UO project websites.</p>
					</div>
				</div>

				{nextButtons()}

				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">Bots & Automation</h1>
				<div className="justify-center mb-6 text-xl px-10 flex flex-col space-y-6 md:space-y-0 md:space-x-16 md:flex-row">
					<div>Ultima Online Scripts</div>
					<div>AutoIt</div>
					<div>RobotJS</div>
					<div>Discord Bot</div>
					<div>Twitter Bot</div>
				</div>
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">Past Projects</h1>
				<div className="justify-center mb-6 md:mb-12 text-xl px-10 flex flex-col space-y-6 md:space-y-0 md:space-x-16 md:flex-row">
					<div>
						<h2 className="text-2xl font-bold mb-2 md:mb-6">Funny Logo Generator</h2>
						<p>This was hosted on my old site, but it was a logo generator for a well known brand involving the black and orange colors.</p>
					</div>
				</div>
			</section>


			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4">
				{WatchCTA()}
			</div>
		</div>
	)
}

const nextButtons = () => {
	return <div className="flex flex-col justify-center space-y-6 md:space-y-0 md:flex-row md:space-x-6 px-10 my-12 text-center md:text-left">
 			<Link to="/about" className="p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">Learn about Jase</Link>
			<Link to="/blog" className="p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">View Blog Posts</Link>
			<Link to="/videos" className="p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">View Videos</Link>
		</div>
	}
	